/**
 * Created by noOne on 26/10/2017.
 */
"use strict";

/**
 * @class
 */
export default class BettyController {
    /**
     * @param peeking {Array}
     * @param pathing {Array}
     * @param paths {Array}
     */
    constructor(peeking, pathing, paths) {

        /**
         * @type {Array}
         * @private
         */
        this._peeking = peeking;

        /**
         * @type {Array}
         * @private
         */
        this._pathing = pathing;

        /**
         * @type {Array}
         * @private
         */
        this._paths = paths;

        /**
         * Max number of pathing betties to have active at a time
         * @type {number}
         * @private
         */
        this._maxPathing = Common.config.max_pathing;

        /**
         * total number of paths
         * @type {number}
         * @private
         */
        this._totalPaths = Common.config.total_paths;

        /**
         * @type {number}
         * @private
         */
        this._startTime = Date.now();

        /**
         * @type {number}
         * @private
         */
        this._nextBettyTime = P3.math.randomInt(
            Common.config.release_interval_min,
            Common.config.release_interval_max
        );

        /**
         * @type {Array}
         * @private
         */
        this._peekTweens = [];

        /**
         * @type {Array}
         * @private
         */
        this._testPath = null;

        this.init();
    }

    init() {
        Common.activePathIds = [];
    }

    incMaxPathing() {
        if (this._maxPathing < this._totalPaths) {
            this._maxPathing++;
        }
    }

    /**
     * @public
     */
    update() {
        const time = Date.now();
        if (time > this._startTime + this._nextBettyTime) {
            this._startTime = time;
            this._nextBettyTime = P3.math.randomInt(
                Common.config.release_interval_min,
                Common.config.release_interval_max
            );
            if (this.countActivePathing() < this._maxPathing) {
                this._wakeRandomPathing();
            } else {
                this._wakeRandomPeeking();
            }
        }
    }

    /**
     * @public
     */
    countActivePathing() {
        let count = 0;
        const len = this._pathing.length;
        for (let i = 0; i < len; i++) {
            if (!this._pathing[i].sleep) count++;
        }
        return count;
    }

    /**
     * @public
     */
    pausePeekTweens(isPause) {
        for (let i = 0; i < this._peekTweens.length; i++) {
            if (isPause) {
                if (this._peekTweens[i]) {
                    this._peekTweens[i].resume();
                } else {
                    this._peekTweens.splice(i, 1);
                }
            } else {
                if (this._peekTweens[i]) {
                    this._peekTweens[i].pause();
                } else {
                    this._peekTweens.splice(i, 1);
                }
            }
        }
    }

    /**
     * @private
     */
    _wakeRandomPeeking() {
        if (Math.random() < 0.75) return;//skip most of them randomly
        this._peeking = Common.shuffleArr(this._peeking);
        const len = this._peeking.length;
        for (let i = 0; i < len; i++) {
            if (this._peeking[i].sleep) {
                //this._peeking[i].wakeUp();
                const tw = this._peeking[i].peek();
                this._peekTweens.push(tw);
                break;
            }
        }
    }

    /**
     * @private
     */
    _wakeRandomPathing() {
        this._pathing = Common.shuffleArr(this._pathing);
        const len = this._pathing.length;
        for (let i = 0; i < len; i++) {
            if (this._pathing[i].sleep) {

                if (!Common.isDebug) this._assignRandomPath(this._pathing[i]);//if not debugging take random path
                else this._pathing[i].path = this._testPath.slice(0);//else use a copy of the test path

                this._pathing[i].wakeUp();

                break;
            }
        }
    }

    /**
     * @returns {Number|Array}
     * @private
     */
    _assignRandomPath(betty) {
        let attempts = 20;
        while (attempts-- > 0) {
            const rand = P3.math.randomInt(0, this._paths.length - 1);
            if (Common.activePathIds.indexOf(rand) === -1) {
                Common.activePathIds.push(rand);
                betty.pathId = rand;
                betty.path = this._paths[rand].slice(0);
                return;
            }
        }
    }

    set testPath(value) {
        this._testPath = value;
    }
}